import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function FAQSection() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    { q: t('faq_q1'), a: t('faq_a1') },
    { q: t('faq_q2'), a: t('faq_a2') },
    { q: t('faq_q3'), a: t('faq_a3') },
    { q: t('faq_q4'), a: t('faq_a4') },
    { q: t('faq_q5'), a: t('faq_a5') },
    { q: t('faq_q6'), a: t('faq_a6') },
    { q: t('faq_q7'), a: t('faq_a7') },
    { q: t('faq_q8'), a: t('faq_a8') },
    { q: t('faq_q9'), a: t('faq_a9') },
    { q: t('faq_q10'), a: t('faq_a10') },
  ];

  return (
    <section id="faq" className="py-12 md:py-16 bg-stone-50">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-stone-800">
            {t('faq_h2')}
          </h2>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="rounded-xl border border-stone-200 bg-white overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                className="w-full flex items-center justify-between px-4 md:px-6 py-4 text-left"
              >
                <span className="text-sm md:text-base font-medium text-stone-800 pr-4">
                  {faq.q}
                </span>
                <i
                  className={`ri-arrow-down-s-line text-lg text-stone-400 transition-transform shrink-0 ${
                    openIndex === idx ? 'rotate-180' : ''
                  }`}
                />
              </button>
              {openIndex === idx && (
                <div className="px-4 md:px-6 pb-4">
                  <p className="text-sm text-stone-600 leading-relaxed border-t border-stone-100 pt-4">
                    {faq.a}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}